module.exports = __webpack_public_path__ + "static/f_capabilities_3_2-5e10b49048ce804bbe00417eb6ee167a.png";